import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import './../../styles/admin/galeria.css';
import './../../styles/admin/productos_edit.css';
import * as globals from './../../components/GlobalScripts.js';
import Admin_Galeria_Modal from './Admin_Galeria_Modal';
import Admin_Variacion_Modal from './Admin_Variacion_Modal';
import { useNavigate } from 'react-router-dom';

const Admin_productos_edit = () => {
    let path_api = localStorage.getItem('path_api');
    const { id } = useParams();
    const isNew = id === 'new';

    const [nombre, setNombre] = useState('');
    const [estado, setEstado] = useState('borrador');
    const [descripcion, setDescripcion] = useState('');
    const [proveedor, setProveedor] = useState('');
    const [envio, setEnvio] = useState('estandar');
    const [categorias, setCategorias] = useState([]);
    const [categoriasOptions, setCategoriasOptions] = useState([]);
    const [etiquetas, setEtiquetas] = useState([]);
    const [etiquetasOptions, setEtiquetasOptions] = useState([]);
    const [data, setData] = useState({ imagenes: [], variaciones: [] }); 

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isVariacionModalOpen, setIsVariacionModalOpen] = useState(false);

    const [editIndex, setEditIndex] = useState(null);
    const [editVariacionData, setEditVariacionData] = useState(null);
    const [isCopyVariacion, setIsCopyVariacion] = useState(false);

    const [searchCategorias, setSearchCategorias] = useState('');
    const [searchEtiquetas, setSearchEtiquetas] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
        if (!isNew) {
            loadProducto();
        }
    }, [isNew]);

    useEffect(() => {
        load_c_c();
    }, []);

    const load_c_c = () => {
        globals.validateSession();
        axios.post(`${path_api}/get_c_c.php`, {
            rute: globals.getRuteBackend()
        }).then(response => {
            if(response.data.mensaje === 'success'){
                setCategoriasOptions(response.data.categorias);
                setEtiquetasOptions(response.data.colecciones);
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: response.data.mensaje || "No se cargaron las categorias y/o colecciones", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            }
        }).catch(error => {
            globals.createAlert({ type: "error", msg_title: "Error", msg: "Error al cargar las categorias y/o colecciones", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
        });
    };

    const loadProducto = () => {
        globals.validateSession();
        axios.post(`${path_api}/admin/productos_edit.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            id: id
        }).then(response => {
            if(response.data.mensaje === 'success' && response.data.producto){
                const p = response.data.producto;
                setNombre(p.nombre);
                setDescripcion(p.descripcion);
                setEstado(p.estado);
                setProveedor(p.proveedor || '');
                setEnvio(p.envio || 'estandar');

                let catArr = [];
                let etArr = [];
                try {
                    catArr = Array.isArray(p.categorias) ? p.categorias : JSON.parse(p.categorias || '[]');
                } catch {
                    catArr = [];
                }
                try {
                    etArr = Array.isArray(p.etiquetas) ? p.etiquetas : JSON.parse(p.etiquetas || '[]');
                } catch {
                    etArr = [];
                }

                setCategorias(catArr);
                setEtiquetas(etArr);

                try {
                    const parsedData = JSON.parse(p.data);
                    const imagenes = (parsedData && Array.isArray(parsedData.imagenes)) ? parsedData.imagenes : [];
                    const variaciones = (parsedData && Array.isArray(parsedData.variaciones)) ? parsedData.variaciones : [];
                    setData({ imagenes, variaciones });
                } catch {
                    setData({ imagenes: [], variaciones: [] });
                }
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: response.data.mensaje || "No se pudo cargar el producto", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            }
        }).catch(error => {
            globals.createAlert({ type: "error", msg_title: "Error", msg: "Error al cargar producto", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
        });
    };

    const saveProducto = async () => {
        if(!nombre) {
            globals.createAlert({ type: "error", msg_title: "Error", msg: "Debes agregar un nombre al producto", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            return;
        }

        if(data.variaciones.length === 0) {
            globals.createAlert({ type: "error", msg_title: "Error", msg: "Debes agregar al menos una variación antes de guardar", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            return;
        }

        globals.validateSession();
        globals.openViewCharge();
        await axios.post(`${path_api}/admin/productos_edit.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            id: isNew ? 'new' : id,
            nombre,
            descripcion,
            estado,
            proveedor,
            envio,
            categorias: JSON.stringify(categorias),
            etiquetas: JSON.stringify(etiquetas),
            data: JSON.stringify(data) 
        }).then(response => {
            if(response.data.mensaje === 'success'){
                globals.createAlert({ type: "success", msg_title: "Éxito", msg: "Producto guardado correctamente", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
                if(isNew){
                    navigate(`/admin/productos/${response.data.id}`);
                }
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: response.data.mensaje || "No se pudo guardar el producto", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            }
        }).catch(error => {
            globals.createAlert({ type: "error", msg_title: "Error", msg: "Error al guardar producto", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
        });
        globals.closeViewCharge();
    };

    const openModalGaleria = () => {
        setIsModalOpen(true);
    };

    const closeModalGaleria = () => {
        setIsModalOpen(false);
    };

    const handleAddImages = (selectedImages) => {
        setData(prev => ({ ...prev, imagenes: [...prev.imagenes, ...selectedImages] }));
        setIsModalOpen(false);
    };

    const openVariacionModal = (variacion = null, isCopy = false) => {
        setEditIndex(variacion ? data.variaciones.indexOf(variacion) : null);
        setEditVariacionData(variacion);
        setIsCopyVariacion(isCopy);
        setIsVariacionModalOpen(true);
    };

    const closeVariacionModal = () => {
        setIsVariacionModalOpen(false);
        setEditIndex(null);
        setEditVariacionData(null);
        setIsCopyVariacion(false);
    };

    const handleAddVariacion = (variacion) => {
        if(editIndex === null || isCopyVariacion) {
            setData(prev => ({ ...prev, variaciones: [...prev.variaciones, variacion] }));
        } else {
            const nuevasVariaciones = [...data.variaciones];
            nuevasVariaciones[editIndex] = variacion;
            setData(prev => ({ ...prev, variaciones: nuevasVariaciones }));
        }
        closeVariacionModal();
    };

    const handleEditVariacion = (index) => {
        const v = data.variaciones[index];
        openVariacionModal(v, false);
    };

    const handleCopyVariacion = (index) => {
        const v = data.variaciones[index];
        openVariacionModal({ ...v }, true);
    };

    const handleDeleteVariacion = (index) => {
        const nuevasVariaciones = data.variaciones.filter((_, i) => i !== index);
        setData(prev => ({ ...prev, variaciones: nuevasVariaciones }));
    };

    const addCategoria = (e) => {
        const selected = e.target.value;
        if(selected && !categorias.includes(selected)) {
            setCategorias(prev => [...prev, selected]);
        }
    };

    const removeCategoria = (cat) => {
        setCategorias(prev => prev.filter(c => c !== cat));
    };

    const addEtiqueta = (e) => {
        const selected = e.target.value;
        if(selected && !etiquetas.includes(selected)) {
            setEtiquetas(prev => [...prev, selected]);
        }
    };

    const removeEtiqueta = (et) => {
        setEtiquetas(prev => prev.filter(e => e !== et));
    };

    const filteredCategorias = categoriasOptions.filter(cat =>
        cat.toLowerCase().includes(searchCategorias.toLowerCase())
    );
    const filteredEtiquetas = etiquetasOptions.filter(et =>
        et.toLowerCase().includes(searchEtiquetas.toLowerCase())
    );

    const handleDeleteImage = (index) => {
        const nuevasImagenes = data.imagenes.filter((_, i) => i !== index);
        setData(prev => ({ ...prev, imagenes: nuevasImagenes }));
    };

    const moveImageLeft = (index) => {
        if (index > 0) {
            const nuevasImagenes = [...data.imagenes];
            const temp = nuevasImagenes[index - 1];
            nuevasImagenes[index - 1] = nuevasImagenes[index];
            nuevasImagenes[index] = temp;
            setData(prev => ({ ...prev, imagenes: nuevasImagenes }));
        }
    };
    
    const moveImageRight = (index) => {
        if (index < data.imagenes.length - 1) {
            const nuevasImagenes = [...data.imagenes];
            const temp = nuevasImagenes[index + 1];
            nuevasImagenes[index + 1] = nuevasImagenes[index];
            nuevasImagenes[index] = temp;
            setData(prev => ({ ...prev, imagenes: nuevasImagenes }));
        }
    };
    

    const return_page = () => {
        navigate(`/admin/productos`);
    };

    const Link_product = `/productos/${id}`;

    return (
        <>
            <h2>{isNew ? 'Nuevo Producto' : `Editando Producto #${id}`}</h2>
            <div className="container-form-producto"> 
                <div className="form-field">
                    {!isNew && (
                        <Link to={Link_product} target='_blank' style={{width: '200px'}}>Ver producto en la tienda</Link>
                    )}
                </div>

                <div className="form-field">
                    <label className="requiered-input">Nombre</label>
                    <input type="text" value={nombre} onChange={e => setNombre(e.target.value)} />
                </div>

                <div className="form-field">
                    <label>Descripción</label>
                    <textarea name="mensaje" className="input-primary" value={descripcion} onChange={(e) => setDescripcion(e.target.value)} 
                    placeholder="Descripcion del producto" rows="5"></textarea>

                </div>

                <div className="form-field">
                    <label>Estado</label>
                    <select value={estado} onChange={e => setEstado(e.target.value)}>
                        <option value="borrador">Borrador</option>
                        <option value="activo">Activo</option>
                        <option value="inactivo">Inactivo</option>
                    </select>
                </div>

                <div className="form-field">
                    <label>Proveedor</label>
                    <input type="text" value={proveedor} onChange={e => setProveedor(e.target.value)} />
                </div>

                <div className="form-field">
                    <label>Envío</label>
                    <select value={envio} onChange={e => setEnvio(e.target.value)}>
                        <option value="estandar">Estandar</option>
                        <option value="gratis">Gratis</option>
                    </select>
                </div>

                <div className="form-field">
                    <label>Categorías</label>
                    <input 
                        type="text" 
                        placeholder="Buscar categorías..." 
                        value={searchCategorias} 
                        onChange={e => setSearchCategorias(e.target.value)} 
                    />
                    <select onChange={addCategoria} value="">
                        <option value="">-- Seleccionar categoría --</option>
                        {filteredCategorias.map((cat, i) => (
                            <option key={i} value={cat}>{cat}</option>
                        ))}
                    </select>
                    {categorias.length > 0 && (
                        <div className="selected-list">
                            {categorias.map((cat, i) => (
                                <div key={i} className="selected-item">
                                    <span>{cat}</span>
                                    <button onClick={() => removeCategoria(cat)} className="remove-button">X</button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div className="form-field">
                    <label>Etiquetas</label>
                    <input 
                        type="text" 
                        placeholder="Buscar etiquetas..." 
                        value={searchEtiquetas} 
                        onChange={e => setSearchEtiquetas(e.target.value)} 
                    />
                    <select onChange={addEtiqueta} value="">
                        <option value="">-- Seleccionar etiqueta --</option>
                        {filteredEtiquetas.map((et, i) => (
                            <option key={i} value={et}>{et}</option>
                        ))}
                    </select>
                    {etiquetas.length > 0 && (
                        <div className="selected-list">
                            {etiquetas.map((et, i) => (
                                <div key={i} className="selected-item">
                                    <span>{et}</span>
                                    <button onClick={() => removeEtiqueta(et)} className="remove-button">X</button>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div className="form-field">
                    <label>Imágenes del producto ({data.imagenes.length})</label>
                    {data.imagenes.length > 0 ? (
                        <div className="product-images-list">
                        {data.imagenes.map((imgObj, idx) => (
                            <div key={idx} className="product-image-item">
                                <button className="delete-image-button" onClick={() => handleDeleteImage(idx)}>
                                    X
                                </button>
                                <img src={imgObj.url} alt={`img-${imgObj.id}`} />
                                <div className="image-actions">
                                    <button 
                                        className="move-left-button" 
                                        onClick={() => moveImageLeft(idx)} 
                                        disabled={idx === 0}
                                    >
                                        <svg viewBox="0 0 24 24">
                                            <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6z" />
                                        </svg>
                                    </button>
                                    <button 
                                        className="move-right-button" 
                                        onClick={() => moveImageRight(idx)} 
                                        disabled={idx === data.imagenes.length - 1} // Deshabilitar si está en el extremo derecho
                                    >
                                        <svg viewBox="0 0 24 24">
                                            <path d="M10.59 6.41L15.17 12l-4.58 4.59L12 18l6-6-6-6z" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                    
                    ) : (
                        <p>No hay imágenes seleccionadas.</p>
                    )}
                    <button onClick={openModalGaleria}>Agregar Imágenes</button>
                </div>

                <div className="form-field">
                    <label className="requiered-input">Variaciones ({data.variaciones.length})</label>
                    {data.variaciones.length > 0 ? (
                        <div className="variations-list">
                            {data.variaciones.map((v, i) => (
                                <div key={i} className="variation-item">
                                    <div className="variation-info">
                                    <span><b>Talla:</b> {v.talla}</span>
                                    <span><b>Color:</b> {v.color} <span style={{ backgroundColor: v.code, display: 'inline-block', width: '16px', height: '16px', borderRadius: '50%', marginLeft: '5px', border: '1px solid var(--color-border)' }}></span></span>
                                    <span><b>Precio:</b> {v.precio}</span>
                                    <span><b>Inventario:</b> {v.ilimitado ? 'Ilimitado' : v.inventario}</span>
                                </div>

                                    <div className="actions">
                                        <button className="edit-button" onClick={() => handleEditVariacion(i)}>
                                            <svg viewBox="0 0 24 24">
                                                <path d="M3 17.25V21h3.75l11-11-3.75-3.75-11 11zM20.71 7.04a1.003 1.003 0 0 0 0-1.41l-2.34-2.34a1.003 1.003 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
                                            </svg>
                                        </button>
                                        <button className="copy-button" onClick={() => handleCopyVariacion(i)}>
                                            <svg viewBox="0 0 24 24">
                                                <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM7 7h10v2H7V7z"/>
                                            </svg>
                                        </button>
                                        <button className="delete-button" onClick={() => handleDeleteVariacion(i)}>
                                            <svg viewBox="0 0 24 24">
                                                <path d="M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1z"/>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p>No hay variaciones agregadas.</p>
                    )}
                    <button onClick={() => openVariacionModal()}>Agregar Variación</button>
                </div>

                <div className="actions">
                    <button onClick={return_page} className="cancel">Regresar</button>
                    <button onClick={saveProducto}>Guardar Producto</button>
                </div>
            </div>

            {isModalOpen && (
                <Admin_Galeria_Modal
                    isOpen={isModalOpen}
                    onClose={closeModalGaleria}
                    onAdd={handleAddImages}
                />
            )}

            {isVariacionModalOpen && (
                <Admin_Variacion_Modal
                    isOpen={isVariacionModalOpen}
                    onClose={closeVariacionModal}
                    onAdd={handleAddVariacion}
                    editData={editVariacionData}
                    isCopy={isCopyVariacion}
                />
            )}
        </>
    );
};

export default Admin_productos_edit;
